import styled from "styled-components/macro";

import { useAdults } from "HouseholdProfile/API/queryHooks";

import FnrStaggeredEntry from "UI/FnrStaggeredEntry";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import UserChip from "../UserChip";

const SFnrVerticalGap = styled(FnrVerticalGap)`
  @media screen and (max-width: 680px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
`;

const Hohs = () => {
  const adults = useAdults();

  return (
    <SFnrVerticalGap gap={0}>
      <FnrStaggeredEntry show noInit gap={4}>
        {adults.map((householdMember) => (
          <UserChip key={householdMember.userID} {...householdMember} />
        ))}
      </FnrStaggeredEntry>
    </SFnrVerticalGap>
  );
};

export default Hohs;
